import { Star, Quote } from "lucide-react";
import { Reveal } from "./Motion";
import { formatDate, DIVISIONS } from "../../lib/api";

const divName = (k) => DIVISIONS.find((d) => d.key === k)?.name || "";
import { useSettings } from "../../lib/settings";

export const ReviewCard = ({ review, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.08} className="h-full">
    <figure className="h-full flex flex-col border hairline bg-[var(--ink-2)] p-6 sm:p-8 transition-colors duration-300 hover:border-[rgba(212,175,55,0.45)]" data-testid={`review-card-${review.id}`}>
      <div className="flex items-start justify-between gap-3">
        <Quote className="w-7 h-7 text-gold shrink-0" />
        <div className="flex flex-wrap justify-end gap-2">
          {divName(review.division) && <span className="text-[0.65rem] font-mono uppercase tracking-wider px-2 py-1 border border-white/15 text-slate-300" data-testid={`review-division-${review.id}`}>{divName(review.division)}</span>}
          {review.is_sample && <span className="text-[0.65rem] font-mono uppercase tracking-wider px-2 py-1 border border-[var(--gold)] text-gold" data-testid={`review-sample-tag-${review.id}`}>Sample Review</span>}
        </div>
      </div>
      {review.rating ? (
        <div className="flex gap-1 mt-5" aria-label={`${review.rating} out of 5`}>
          {[1, 2, 3, 4, 5].map((n) => (
            <Star key={n} className={`w-4 h-4 ${n <= review.rating ? "fill-[var(--gold)] text-gold" : "text-slate-600"}`} />
          ))}
        </div>
      ) : null}
      <blockquote className="font-display text-xl md:text-2xl leading-snug text-slate-100 mt-5 flex-1">&ldquo;{review.body}&rdquo;</blockquote>
      <figcaption className="mt-8 pt-5 border-t hairline">
        <p className="text-sm font-semibold text-slate-100">{review.display_name}</p>
        <p className="text-xs text-slate-400 mt-1">{[review.company, formatDate(review.review_date)].filter(Boolean).join(" · ")}</p>
      </figcaption>
    </figure>
  </Reveal>
);

export const ReviewsPlaceholder = () => {
  const s = useSettings();
  return (
    <div className="border border-dashed border-[rgba(212,175,55,0.35)] p-10 md:p-16 text-center" data-testid="reviews-placeholder">
      <Quote className="w-9 h-9 text-gold mx-auto" />
      <p className="font-display text-2xl md:text-4xl text-slate-100 max-w-3xl mx-auto mt-6 leading-snug">{s.reviews_placeholder}</p>
    </div>
  );
};

export const ReviewsGrid = ({ reviews }) =>
  reviews.length ? (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="reviews-grid">
      {reviews.map((r, i) => <ReviewCard key={r.id} review={r} i={i} />)}
    </div>
  ) : (
    <ReviewsPlaceholder />
  );
